import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import LocalizedText from '@LocalizedText';
import {
  HELP_SECTION_ART_SIZE_POSITION,
  HELP_TOPIC_ART_SIZE_POSITION_STB_LINES,
  HELP_SECTION_SAFETY_TRIM_AND_BLEED,
} from '@app/constants';

import SvgIconUse from '@SvgIconUse';
import HelpTip from '@components/help/help-tip/HelpTip';

import RotateTool from '../tools/rotate-tool/RotateTool';
import MoveTool from '../tools/move-tool/MoveTool';
import ScaleTool from '../tools/scale-tool/ScaleTool';
import FitTool from '../tools/fit-tool/FitTool';
import Button from '@components/buttons/Button';
import { inject } from '@app/providers/QAU.ContextProvider';
import { connect } from 'react-redux';
import { isDesignIn } from '@app/utils/utils';

const PositionGroup = ({ isDesignIn, toggleOverlay, visible, disabled, ...props }) => {
  const moveArtLayout = useRef(null);

  useEffect(() => {
    moveArtLayout.current = (
      <div id="qau-toolgroup-position">
        <ScaleTool />
        <div>
          <FitTool />
          <HelpTip
            tipLocKey="qau-safety-bleed-lines-text"
            helpSection={isDesignIn ? HELP_SECTION_SAFETY_TRIM_AND_BLEED : HELP_SECTION_ART_SIZE_POSITION}
            helpTopic={HELP_TOPIC_ART_SIZE_POSITION_STB_LINES}
          />
        </div>
        <RotateTool />
        <MoveTool />
      </div>
    );
  }, [isDesignIn, moveArtLayout]);

  return (
    visible && (
      <Button disabled={disabled} onClick={e => toggleOverlay(e, moveArtLayout.current)} {...props}>
        <SvgIconUse id='position' />
        <LocalizedText id='qau-toolgroup-position' tagName='span' />
      </Button>
    )
  );
};

const mapStateToProps = (state, { flow: { flowConfig } }) => ({ isDesignIn: isDesignIn(flowConfig) });

PositionGroup.propTypes = {
  toggleOverlay: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  isDesignIn: PropTypes.bool.isRequired,
};

export default inject('flow')(connect(mapStateToProps)(PositionGroup));
